import { Badge } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { categoryColor, FAILURE_CATEGORIES } from './runError';

/** forun's failure category (transient, data, config, resources, bug) as a small badge. */
export function FailureBadge({ category }: { category?: string }) {
  const { t } = useTranslation('runs');
  if (!category) return null;
  const known = (FAILURE_CATEGORIES as readonly string[]).includes(category);
  return (
    <Badge size="xs" variant="light" color={categoryColor(category)} miw="max-content" style={{ flexShrink: 0 }}>
      {known ? t(`failure.category.${category}`) : category}
    </Badge>
  );
}

/** "low priority" / "pool only" for a run sent to forun with non-default scheduling. */
export function SchedulingNote({ priority, allowOverflow }: { priority?: string | null; allowOverflow?: boolean | null }) {
  const { t } = useTranslation('runs');
  const parts = [priority === 'low' ? t('scheduling.low') : null, allowOverflow === false ? t('scheduling.poolOnly') : null].filter(Boolean);
  if (!parts.length) return null;
  return (
    <Badge size="xs" variant="light" color="gray">
      {parts.join(' · ')}
    </Badge>
  );
}
